module.exports = __webpack_public_path__ + "media/img/Landing_Page/homepage-banner-01-474569351ed3bf63be4e55ae4dd0a907.jpg";